import { z } from 'zod';

export const validationLoginData = z.object({
  email: z.string()
    .transform(val => val.trim().toLowerCase())
    .refine(val => z.string().email().safeParse(val).success, { message: 'Некорректный email' }),
  password: z.string().min(8, { message: 'Пароль должен содержать не менее 8 символов' }),
});

export type LoginData = z.infer<typeof validationLoginData>;